<img [attr.data-src]="defaultImg" [attr.data-srcset]="srcset" [title]="title" [alt]="alt ? alt : ''" class="lazyload" loading="lazy">
<ng-content></ng-content>